const clamp = (value, min, max) => {
    if (value > max) {
        return max;
    }
    if (value < min) {
        return min;
    }
    return value;
};
// TODO write unit test
export const pluralize = (count, words) => {
    const cases = [2, 0, 1, 1, 1, 2];
    const x = count % 100 > 4 && count % 100 < 20 ? 2 : cases[clamp(count % 10, 0, 5)];
    return words[x];
};
